import { ChevronDownIcon } from "@chakra-ui/icons"
import { Accordion, AccordionButton, AccordionItem, AccordionPanel, Box, Icon } from "@chakra-ui/react"

export const FAQSection = ({ data }) => {
    return (
        <Accordion allowMultiple minW={{ base: '18.75rem', lg: '31.25rem' }}>
            {data.map((item, index) => (
                <AccordionItem key={index} mt={2} border="none" data-group role="group">
                    {({ isExpanded }) => (
                        <Box boxShadow={isExpanded ? "md" : "none"} borderRadius="md" transition="250ms" _groupHover={{ boxShadow: "md" }}>
                            <AccordionButton
                                borderRadius="md"
                                border={`1px solid`}
                                borderBottomWidth={isExpanded ? "1px" : "0px"}
                                borderColor={isExpanded ? "rarchy-border" : "transparent"}
                                bg="rarchy-bg-subtle"
                                transition="250ms"
                                _hover={{ bg: "rarchy-bg-white", borderColor: "rarchy-border" }}
                                _expanded={{ bg: "rarchy-bg-white", borderColor: "rarchy-border", borderBottom: "none", borderBottomRadius: "none" }}
                            >
                                <Icon
                                    as={ChevronDownIcon}
                                    color={isExpanded ? "fg.muted" : "fg.subtle"}
                                    _groupHover={{ color: "fg.muted" }}
                                    fontSize="3xl !important"
                                    transform={isExpanded ? 'rotate(180deg)' : undefined}
                                    mr={4}
                                />
                                <Box
                                    as='span'
                                    flex='1'
                                    paddingY='4'
                                    textAlign='left'
                                    textStyle='body'
                                    fontWeight='bold'
                                    color={isExpanded ? "rarchy-link" : "fg.default"}
                                    _groupHover={{ color: 'rarchy-link' }}
                                >
                                    {item.title}
                                </Box>
                            </AccordionButton>
                            <AccordionPanel px={14} color="fg.default" borderRadius="md" border="1px solid" borderColor={isExpanded ? "rarchy-border" : "transparent"} borderTop="none" borderTopRadius="none">
                                {item.answer}
                            </AccordionPanel>
                        </Box>
                    )}
                </AccordionItem>
            ))}
        </Accordion>
    )
}